import Swal from "sweetalert2";

export const ShowBasicAlert = (options: any) => {
    return Swal.fire({
        ...options,
        customClass: 'sweet-alerts',
    });
}

export const CloseAlert = () => {
    Swal.close();
}

export const ShowLoadingAlert = () => {
    Swal.showLoading(null)
}
